import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { environment } from '@env/environment.prod';
import { Observable } from 'rxjs';
import { Habitacion } from '@core/model/habitacion.model';
import { Paginated } from '../model/paginated.model';
import { confPaginated, paramsNext } from '@core/constants/paginacion.const';

@Injectable({
  providedIn: 'root'
})
export class HabitacionService extends BaseAPIClass {
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/habitaciones';
  }

  getAll(): Observable<any> {
    const filterObject = {
      paginacion: confPaginated.quantity
    };
    return super.getAll(filterObject);
  }

  listado(param?: any): Observable<Habitacion[]> {
    // lista las  habitaciones con su estado

    if (param) {
      const params = new HttpParams()
        .append('inicio', param.start)
        .append('fin', param.end);
    }
    return this.httpClient.get<any[]>(this.baseUrl + `/listado`, {
      params: param ? param : null
    });
  }

  registerReserva(data: any) {
    return this.httpClient.post(this.baseUrl + '/registrar', data);
  }

  getDataReserva(idHabitacion: any) {
    return this.httpClient.get(this.baseUrl + '/datos/' + idHabitacion);
  }

  getByUrl(
    formBusqueda: { termino: string; tipoHabitacion: number },
    totalPaginacion?: number
  ) {
    // return this.httpClient.get(this.baseUrl + '/datos/' + idHabitacion);
    const params = new HttpParams().set('paginacion', String(totalPaginacion));
    return this.httpClient.get<Paginated>(
      this.baseUrl +
        `?tipo_habitacion_id=${formBusqueda.tipoHabitacion}&term=${formBusqueda.termino}`,
      { params: params }
    );
  }

  listadoPorPisoHabitacion(param?: any): Observable<Habitacion[]> {
    // lista las  habitaciones con su estado

    if (param) {
      const params = new HttpParams()
        .append('edificio_id', param.edificio_id)
        .append('tipo_habitacion_id', param.tipo_id)
        .append('piso', param.piso);
      console.log(param);
    }
    return this.httpClient.get<any[]>(this.baseUrl + `/listado`, {
      params: param ? param : null
    });
  }

  getHabitacionPisos(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + `/pisos`);
  }

  deleteRegistroReserva(registro_id: any) {
    return this.httpClient.delete<any>(
      this.baseUrl + `/registros/${registro_id}`
    );
  }

  getAllPaginate() {
    const params = new HttpParams().set('paginacion', String(17));
    return this.httpClient.get<any>(this.baseUrl, { params: params });
  }
}
